module.exports = __webpack_public_path__ + "img/Icon_LockOpen_InactiveGray.3b4d29a6.svg";